const COMPONENT_NAME = "DrawerV2";
const CLOSE_BUTTON_ID = "drawer-close-btn";
const BACK_BUTTON_ID = "drawer-back-btn";
const TITLE_ID = "dialog-title";
const HEADER_ID = "drawer-header";
const BODY_ID = "drawer-body";
const DRAWER_WIDTH = "350px";
const STICKYWRAPPER_ZINDEX = 99;
const ICON_SIZE = "18px";
export {
  BACK_BUTTON_ID,
  BODY_ID,
  CLOSE_BUTTON_ID,
  COMPONENT_NAME,
  DRAWER_WIDTH,
  HEADER_ID,
  ICON_SIZE,
  STICKYWRAPPER_ZINDEX,
  TITLE_ID
};
